<div class="w-100">
    <canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="barChartType">
    </canvas>
</div>